"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ChartLoader = function () {
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.loading },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.loading_1 }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.loading_2 }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.loading_3 }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.loading_4 })));
};
exports.default = ChartLoader;
